import React, { FC } from 'react';
import { Box, Theme } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';

interface SpacerProps {
  value: number;
  mobile?: number;
}

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    marginTop: ({ mobile, value }: SpacerProps) => mobile || value,
    [theme.breakpoints.up('sm')]: {
      marginTop: ({ value }: SpacerProps) => value,
    },
  },
}));

const Spacer: FC<SpacerProps> = (props) => {
  const classes = useStyles(props);
  return <Box className={classes.root} />;
};

export default Spacer;
